import { render } from "./JsonViewItem.vue?vue&type=template&id=89c30dce&scoped=true"
import script from "./JsonViewItem.vue?vue&type=script&lang=js"
export * from "./JsonViewItem.vue?vue&type=script&lang=js"

import "./JsonViewItem.vue?vue&type=style&index=0&id=89c30dce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c30dce"]])

export default __exports__